
import HeroSection from './components/HeroSection';
import AboutIntro from './components/AboutIntro';
import ServicesSnapshot from './components/ServicesSnapshot';
import WhyChooseUs from './components/WhyChooseUs';
import CTASection from './components/CTASection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <AboutIntro />
      <ServicesSnapshot />
      <WhyChooseUs />
      <CTASection />
    </div>
  );
}
